export default "__VITE_ASSET__7Ul0f3mD__"